import { create } from 'zustand';
import FixRotationService from '@modules/fixRotation/fixRotationService';
import { subscribeWithSelector } from 'zustand/middleware';
import HalfEdgeMesh from '@/modules/three/common/halfEdgeMesh/HalfEdgeMesh.js';

export type rotationPhase = 'start' | 'select' | 'fixed' | 'done';

interface FixRotationStoreState {
  fixRotationService: FixRotationService | null;
  setFixRotationService: (service: FixRotationService | null) => void;
  rotationPhase: rotationPhase;
  setRotationPhase: (phase: rotationPhase) => void;
  upperJawMesh: HalfEdgeMesh | null;
  setUpperJawMesh: (mesh: HalfEdgeMesh | null) => void;
  lowerJawMesh: HalfEdgeMesh | null;
  setLowerJawMesh: (mesh: HalfEdgeMesh | null) => void;
  reset: () => void;
}

const fixRotationStore = create(
  subscribeWithSelector<FixRotationStoreState>((set) => ({
    fixRotationService: null,
    setFixRotationService: (service: FixRotationService | null) => {
      set({ fixRotationService: service });
    },

    rotationPhase: 'start',
    setRotationPhase: (phase: rotationPhase) => {
      set({ rotationPhase: phase });
    },

    upperJawMesh: null,
    setUpperJawMesh: (mesh: HalfEdgeMesh | null) => {
      set({ upperJawMesh: mesh });
    },
    lowerJawMesh: null,
    setLowerJawMesh: (mesh: HalfEdgeMesh | null) => {
      set({ lowerJawMesh: mesh });
    },
    reset: () =>
      set(() => ({
        fixRotationService: null,
        rotationPhase: 'start',
        upperJawMesh: null,
        lowerJawMesh: null,
      })),
  })),
);

export default fixRotationStore;
